import { render, staticRenderFns } from "./DropzoneUploader.vue?vue&type=template&id=60d24d85&scoped=true&"
import script from "./DropzoneUploader.vue?vue&type=script&lang=js&"
export * from "./DropzoneUploader.vue?vue&type=script&lang=js&"
import style0 from "./DropzoneUploader.vue?vue&type=style&index=0&id=60d24d85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d24d85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VFileInput,VForm,VProgressLinear,VSimpleTable})
